import React from "react";

import { CrmIntegrationStep } from "./CrmIntegrationStep";

export default {
  title: "Onboarding/CrmIntegrationStep",
  component: CrmIntegrationStep,
  parameters: {
    hubly: { data: { hub: { selected: { inProgress: false, percent: 0 } } } },
  },
  decorators: [
    (story) => {
      return <div style={{ padding: "3rem" }}>{story()}</div>;
    },
  ],
};

const Template = (args) => {
  return <CrmIntegrationStep {...args} />;
};

export const Default = Template.bind({});
Default.args = {};
